import React from 'react';
import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export default function useGetSuggestedSearches(query, length) {
  const common = (v, len) => ({ params: v ? { query: v, highlight_size: len } : null });
  const [state, q] = useAxios({
    cache: { ignoreCache: true },
    url: '/api/v1/suggested_searches',
    method: 'GET',
    ...common(query, length),
  }, { manual: true });
  const executeQuery = React.useCallback((newQuery, size) => q(common(newQuery, size)), [q]);
  return [state, executeQuery];
}
